import React,{useState,useEffect,useCallback} from 'react';
import { useHistory,useParams,useLocation} from "react-router-dom";
import axios from "../../utils/axios";
import Swal from 'sweetalert2'
import Moment from 'moment';
import { getToken } from '../../utils/Common';
import { setUserSession } from '../../utils/Common';
import DataTable from 'react-data-table-component';
import HEAD from '../../component/header'
import SIDE from '../../component/navbar'
import { Image,Transformation } from 'cloudinary-react';
import { Modal, ModalFooter } from 'react-bootstrap';

function WaitingItem() {

const token = getToken();
const headers = { Authorization: `Bearer ${token}`,'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' };
const history = useHistory();
const FileDownload = require('js-file-download');
// Session
const session = localStorage.getItem('user');
const udeptID = JSON.parse(session).dept_id;
const hcode = JSON.parse(session).hotel_id;

// Var
const [listItem, setListItem] = useState([]);
const [hotelList, setHotelList] = useState([]);

const [openModalImg, setOpenModalImg] = useState(false);
const [imgItem, setImgItem] = useState();

const getListHotelbyUser = useCallback (() => {
    axios
    .post(`/api/list/hotel/by-user`,{hcode},{headers:headers})
    .then(function (response) {
        setHotelList(response.data)
    })
    .catch(function (error) {
        console.log("Error API Hotel: ", error);
    });
},[hcode,headers]);

const ExpandedComponent = ({ data }) => <pre>{data.title}</pre>;

const openImage = (url) => {
    setImgItem(url)
    setOpenModalImg(true)
}

const downloadItemList = () => {
    axios
    .get(`/api/generate/excel/items/${hcode}/${udeptID}`,
        {responseType: 'blob'},
        {headers:headers}
    )
    .then(function (response) {
        console.log(response.data);
        FileDownload(response.data, 'item_list.xlsx');
    })
    .catch(function (error) {
        console.log(error)
    });
}

const columns = [
    {
        name: 'ID',
        width: '100px',
        wrap: true,
        selector: row => row.id_item,
    },
    {
        name: 'Thumbnail',
        grow: 0,
        cell: row => 
        <Image style={{width:"80px"}} cloudName="cloud-prima-hotel-indonesia" publicId={row.img_item} onClick={()=>openImage(row.img_item)}>
            <Transformation overlay="phi_png" />
            <Transformation width="500" crop="scale"/>
            <Transformation opacity="20" />
            <Transformation flags="layer_apply" gravity="center" />
        </Image>
    },
    {
        name: 'Item',
        width: '200px',
        wrap: true,
        selector: row => row.nama_item,
    },
    {
        name: 'Group',
        wrap:true,
        cell: (row) => (
            <div>
            <b>{row.group_item} </b> 
            </div>
        ),
    },
    {
        name: 'Min Order',
        wrap:true,
        cell: (row) => (
            <div>
                <i>{row.min_order}/{row.unit} </i> 
            </div>
        ),
    },
    {
        name: 'Item Desc',
        wrap:true,
        cell: (row) => (
            <div style={{paddingTop:"10px",paddingBottom:"10px",color:"#580C30"}}>
            {row.desc_item}
            </div>
        ),
    },
    {
        name: 'Dept',
        cell: (row) => row.code_department,
    },
    {
        name: 'For',
        cell: (row) => row.code_hotel,
    },
    {
        name: 'Status',
        wrap:true,
        cell: (row) => (
            <>
                <i>{row.stts_item === 0
                    ? 'Active'
                    : 'Waiting'
                }
                </i>
            </>
        )
    },
    {
        name: '',
        width: '50px',
        cell: (row) => (
            <div>
                <i class="bi bi-search" onClick={()=>history.push(`/detail/item/${row.id_item}`)}></i>
            </div>
        ),
    },
];

 // Search 
 const [filtertext, setFilterText] = useState('');
 const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

 const filteredItems = listItem.filter(
     search => (Object.values(search).join('').toLowerCase().includes(filtertext.toLowerCase()))
 );

 const handleClear = () => {
     if (filtertext) {
         setResetPaginationToggle(!resetPaginationToggle);
         setFilterText('');
     }
 };

const getListitemWaiting =  useCallback ((hotel) => {

    if(hotel){
        const hcode = hotel;
        axios
        .get(`/api/list/item/waiting`,{headers:headers})
        .then(function (response) {
            console.log(response.data)
            setListItem(Object.values(response.data).flatMap(arr => arr));
        })
        .catch(function (error) {
           console.log("Error getAPIListPPW: ", error);
           
        });
    }
    else
    {

        axios
        .get(`/api/list/item/waiting`,{headers:headers})
        .then(function (response) {
            console.log(response.data);
            setListItem(Object.values(response.data).flatMap(arr => arr));
        })
        .catch(function (error) {
            console.log("Error getAPIListPPW: ", error);
        
        });
    }    

},[udeptID,hcode,headers]);

useEffect(() => {
    getListitemWaiting(); 
    getListHotelbyUser();
}, []);


return (
   <>
   <HEAD />
   <SIDE />

   <main id="main" className="main">

    <div className="pagetitle">
      <h1>Waiting Item</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a >Home</a></li>
          <li className="breadcrumb-item ">Item Waiting</li>
          <li className="breadcrumb-item active">List</li>
        </ol>
      </nav>
    </div>

    <section>

      <div className='row'>
        <div className='col-12'>
        <div className="card">
            <div className="card-body">
              <div className="card-title">
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>getListitemWaiting()}><i className="bi bi-arrow-clockwise"></i></button>
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>downloadItemList()}><i className="bi bi-printer"></i></button>
              </div>

              <div className='row p-2 mb-2'>
               
                    <div className="col-8">
                        <input type="text" className="form-control" placeholder="Search" onChange={e => setFilterText(e.target.value)} onClear={()=>handleClear} filtertext={filtertext}/>
                    </div>

                    <div className="col-4">
                    <select id="hotelSelect" className="form-select" onChange={(e)=>getListitemWaiting(e.target.value)}>
                            <option>Group By Hotel</option>
                            {hotelList.map((x, t) => (
                                x.map((v, k) => (
                                    <option key={k} value={v.id_hotel}>
                                        {v.code_hotel} - {v.nm_hotel}
                                    </option>
                                ))
                            ))}  
                            </select>
                    </div>
               
                   
              </div>

              <div className='row'>
              <DataTable
                        columns={columns}
                        data={filteredItems}
                        fixedHeader
                        fixedHeaderScrollHeight="440px"
                        pagination
                        // expandableRows
                        // expandableRowsComponent={ExpandedComponent}
                    />
              </div>
              
            </div>
          </div>
        </div>
      </div>

    </section>

    </main>


    {/* Modal Show Image Item */}
    <Modal show={openModalImg} onHide={()=>setOpenModalImg(false)}>
      <Modal.Body>
      <div class="row">
          <div class="col-lg-12 col-md-12 text-center">
          <Image style={{width:"400px",height:"380px"}} cloudName="cloud-prima-hotel-indonesia" publicId={imgItem} >
              <Transformation overlay="phi_png" />
              <Transformation width="500" crop="scale"/>
              <Transformation opacity="20" />
              <Transformation flags="layer_apply" gravity="center" />
          </Image>
          </div>
        </div>
      
      </Modal.Body>
     
    </Modal>
   
   </>
)
}

export default WaitingItem